import { IHinhThucThiActionTypes } from "../../action-types/category/IHinhThucThiActions";
import { IHinhThucThiReducer } from "../../reducer-model/category/IHinhThucThiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState: IHinhThucThiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  hinhThucThis: [],
};

export const hinhThucThiReducer = (
  state: IHinhThucThiReducer = iniState,
  action: IHinhThucThiActionTypes
): IHinhThucThiReducer => {
  switch (action.type) {
    case "HINH_THUC_THI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "HINH_THUC_THI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        hinhThucThis: action.payload,
      };
    case "HINH_THUC_THI_LOAD_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
